/* eslint-disable radix */
import { merge } from 'ramda';
import {
  FAIL, SUCCESS, REQUEST,
  OPTIONS_SUCCESS
} from 'src/store/actions/passingGroupsActions';

const initialState = {
  list: [],
  options: [],
  fetching: false,
  errors: []
};

const departmentsReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST:
      return merge(state, { fetching: true, list: [] });
    case SUCCESS:
      return merge(state, { list: action.passingGroups, fetching: false });
    case FAIL:
      return merge(state, { errors: action.err, fetching: false });
    case OPTIONS_SUCCESS:
      return merge(state, { options: action.passingGroupsOptions });
    default:
      return state;
  }
};

export default departmentsReducer;
